module.exports = __webpack_public_path__ + "static/pic01-d6d562c427a0452f2291c0bbf735095a.jpg";